// extracted by mini-css-extract-plugin
export default {"card":"CatItem_card__bswcL","heart":"CatItem_heart__sIroL","focus":"CatItem_focus__hoCfF"};